module.exports = __webpack_public_path__ + "static/media/close-icon.5072e49c.svg";